import React from 'react'

export default function DocumentFieldsTable({ rows }) {
  if (!rows?.length) {
    return <p className="text-xs text-slate-500 m-0">No extracted fields on file.</p>
  }

  return (
    <table className="w-full text-sm mt-3">
      <tbody>
        {rows.map((row, idx) => (
          <tr key={`${row.label}-${idx}`} className="border-b border-slate-100">
            <td className="py-1.5 pr-2 text-slate-500 w-[40%] align-top">{row.label}</td>
            <td className="py-1.5 font-semibold text-slate-900 align-top">
              {row.value}
              {row.confidence != null && (
                <span className="text-[11px] text-emerald-700 font-semibold ml-1.5">{row.confidence}%</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
